import CustomLogo from 'assets/svg/logo-ralali-custom/logo-ralali-custom.svg'
import LogoRamadhan from 'assets/svg/logo-ralali-custom/logo-ralali-white.svg'
import Logo from 'assets/svg/logo-ralali-default/logo-ralali-default.svg'
import { ACTIVE_THEME_NAME } from 'common/constants'

function HeaderLogo(): JSX.Element {
  if (ACTIVE_THEME_NAME === 'anniversary')
    return <CustomLogo data-testid="header-logo-custom" />
  if (ACTIVE_THEME_NAME === 'ramadhan')
    return <LogoRamadhan data-testid="header-logo-ramadhan" />
  return <Logo data-testid="header-logo-default" />
}

export default HeaderLogo
